export const HEADERS = {
  'x-csrf-token': Liferay.authToken,
  'Accept-Language': Liferay.ThemeDisplay.getLanguageId().replace('_', '-'),
};

export const ENDPOINTS = {
  facilities: (scopeKey) => `o/c/facilitieses/scopes/${scopeKey}?pageSize=0`,
  categories: (vocabularyId) => `o/headless-admin-taxonomy/v1.0/taxonomy-vocabularies/${vocabularyId}/taxonomy-categories`,
  visitingHours: (facilityId) => `o/c/facilitieses/${facilityId}/facilityToVisitingPatientHours`,
  webContentByKey: (scopeKey, key) => `o/headless-delivery/v1.0/sites/${scopeKey}/structured-contents/by-key/${key}`,

};